<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @Refresh="refresh" @popupOpen="popupOpen" :scrId="scrId"></table-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-5">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<form-view :scrId="scrId"></form-view>
				</sf-card>
			</div>
		</div>
		<popup-view ref="popupView" @popupOpen="popupOpen" :scrId="scrId" />
	</div>
</template>

//
<script>
import SearchView from './Search/SearchView.vue';
import TableView from './Table/TableView.vue';
import FormView from './Table/FormView.vue';
import PopupView from './Popup/PopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchView,
		TableView,
		FormView,
		PopupView
	},
	methods: {
		refresh() {
			this.$refs.searchView.searchList();
		},
		popupOpen(param) {
			this.$refs.popupView.open(param);
		}
	}
};
</script>

<style></style>
